import { colors } from '../../colors';
var jumplink = {
  bgColor: colors.equinePearl,
  borderColor: colors.overcast,
  linkColor: colors.equineStone
};
export default jumplink;